import React from "react"
import PropTypes from "prop-types"
import styles from "./DataTableItem.module.css"
import { ChevronRight } from "react-feather"
import { Text, Paragraph } from "ui/Typography"
import { Button, Flex } from "antd"

const DataTableItem = ({ data, onClick, extraRows, actionIcon, setOpenActionDrawer, onActionIconClick, labelMap, fieldOrder, fullsizeColumnOnMobile }) => {
  return (
    <div className={styles.item}>
      <Flex align="center">
        <div className="flex-1">
          {(fieldOrder || Object.keys(data)).map((key) => {
            if (key === "id") return null
            const label = labelMap?.[key] || key
            const value = data[key]
            
            // Safely handle different value types
            let displayValue = '';
            try {
              if (React.isValidElement(value)) {
                // Render React elements directly
                displayValue = value;
              } else if (value && typeof value === 'object') {
                // Handle circular references
                const getCircularReplacer = () => {
                  const seen = new WeakSet();
                  return (key, value) => {
                    if (typeof value === 'object' && value !== null) {
                      if (seen.has(value)) return '[Circular]';
                      seen.add(value);
                    }
                    return value;
                  };
                };
                displayValue = JSON.stringify(value, getCircularReplacer(), 2);
              } else {
                displayValue = String(value || '');
              }
            } catch (e) {
              console.warn(`Could not stringify value for ${label}:`, e);
              displayValue = '[Complex Value]';
            }
              
            return (
              <Button type="text" className={`w-full ${styles.row}`} key={label} onClick={onClick}>
                <Text className={styles.label}>{label}</Text>
                {React.isValidElement(displayValue) ? (
                  displayValue
                ) : (
                  <Paragraph
                    className={styles.value}
                    ellipsis={{
                      rows: 2
                    }}
                  >
                    {displayValue}
                  </Paragraph>
                )}
              </Button>
            )
          })}
          {extraRows && (
            <Button type="text" className="justify-between w-full" onClick={onClick}>
              {!fullsizeColumnOnMobile &&
              <Text className={styles.label}></Text>
              }
              <Button
                className={styles.value}
                type="text"
                onClick={(e) => {
                  if (setOpenActionDrawer) setOpenActionDrawer(true)
                  e.stopPropagation()
                  if (onActionIconClick) onActionIconClick()
                }}
              >
                {extraRows}
              </Button>
            </Button>
          )}

          
        </div>
        {actionIcon ? (
          <Button
            type="text"
            onClick={(e) => {
              if (setOpenActionDrawer) setOpenActionDrawer(true)
              e.stopPropagation()
              if (onActionIconClick) onActionIconClick()
            }}
          >
            {actionIcon}
          </Button>
        ) : (
          <ChevronRight onClick={onClick} className={styles.arrow} />
        )}
      </Flex>
    </div>
  )
}

DataTableItem.propTypes = {
  data: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  onActionIconClick: PropTypes.func,
  extraRows: PropTypes.node,
  actionIcon: PropTypes.node,
  setOpenActionDrawer: PropTypes.func,
  labelMap: PropTypes.object,
  fieldOrder: PropTypes.array,
  fullsizeColumnOnMobile: PropTypes.bool
}

export default DataTableItem

